export const JoinposterIframeNavigation_tabsTypes = {
  BASIC_DATA: "BASIC_DATA",
  ASSORTMENT: "ASSORTMENT"
};

export const JoinposterIframeNavigation = [
  { name: "Основні дані", type: JoinposterIframeNavigation_tabsTypes.BASIC_DATA }, {
    name: "Асортимент",
    type: JoinposterIframeNavigation_tabsTypes.ASSORTMENT
  }
];

export const MerchantNavigation_tabsTypes = {
  PERSONNEL: "PERSONNEL",
  SHOPS: "SHOPS"
};
